module.exports = __webpack_public_path__ + "static/media/proj1_img8.13b53cc0.jpg";